import React from "react";
import { createGlobalStyle } from "styled-components";
import { useTheme } from "../contexts/ThemeContext";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "quill/dist/quill.bubble.css";
// Componente wrapper que usa o theme

// GlobalStyle que aceita props com as cores do theme
export const GlobalStyle = createGlobalStyle`
    :root {
      --primary: ${(props) => props.theme.primary};
      --secondary: ${(props) => props.theme.secondary};
      --background: ${(props) => props.theme.background};
      --backgroundSecondary: ${(props) => props.theme.backgroundSecondary};
      --textPrimary: ${(props) => props.theme.textSecondary};
      --textSecondary: ${(props) => props.theme.textSecondary};
      --border: ${(props) => props.theme.border};
    }

    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f120;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.primary || "#7C3AED"};
        border-radius: 20px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: ${(props) => props.theme.primary || "#7C3AED"}30;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f120;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.primary || "#7C3AED"}75;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: ${(props) => props.theme.primary || "#7C3AED"}75;
    }

    body{
        margin: 0px !important;
        background-color: ${(props) =>
          props.theme.background || "#fafafb"} !important;
        color: ${(props) => props.theme.textSecondary};
        transition: background-color 0.3s ease, color 0.3s ease;
    }

    * {
        font-family: 'Montserrat', sans-serif !important;
    }

    html {
        font-size: 14px;
        position: relative;
        min-height: 100%;
    }
    
    .ant-form-item {
        margin-bottom: 10px !important;
    }

    .ant-layout-content {
        background-color: ${(props) => props.theme.background || "#fafafb"} !important;
        transition: background-color 0.3s ease;
    }
`;

const ThemedGlobalStyle = () => {
  const { theme } = useTheme();

  return <GlobalStyle theme={theme} />;
};

export default ThemedGlobalStyle;
